var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:[
    'button is-rounded ' + _vm.size + ' ' + _vm.type,
    { 'is-loading': _vm.ajaxloading[_vm.loadingKey] },
  ],attrs:{"native-type":"submit"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }